import React, { useEffect, useState } from 'react'

import { Popup } from 'semantic-ui-react'
import { TwitterPicker as UnstyledTwitterPicker } from 'react-color'
import styled from 'styled-components'

const TwitterPicker = styled(UnstyledTwitterPicker)`
  input {
    text-transform: uppercase;
  }
`
/**
 * @typedef ColorInputProps
 * @property {string} [data-property]
 * @property {string} [color]
 * @property {string} [defaultColor]
 * @property {function} onColorChange
 * @property {string=} fieldName
 * @property {boolean=} disabled
 * @property {object[]} colorOptions
 *
 * @param {ColorInputProps} props
 * @returns
 */
export default function ColorInput({
  'data-property': dataProperty,
  color,
  defaultColor,
  onColorChange,
  fieldName,
  disabled,
  colorOptions,
}) {
  const [openColorPicker, setOpenColorPicker] = useState(false)
  const [colorState, setColorState] = useState(color || defaultColor)

  useEffect(() => {
    setColorState(color)
  }, [color])

  return (
    <div className="field">
      <div className="field relative p-0">
        <label>{fieldName}</label>
        <Popup
          basic
          wide
          content={
            <TwitterPicker
              colors={colorOptions}
              color={colorState}
              onChangeComplete={(e) => {
                const hexColor = e.hex.toUpperCase()
                onColorChange(hexColor)
                setColorState(hexColor)
              }}
              triangle="hide"
            />
          }
          on="click"
          pinned
          position="bottom right"
          style={{ padding: 0 }}
          eventsEnabled
          open={openColorPicker}
          onClose={() => setOpenColorPicker(false)}
          onOpen={() => !disabled && setOpenColorPicker(true)}
          trigger={
            <div className="cursor-pointer select-none">
              <input
                data-property={dataProperty}
                type="text"
                style={{ opacity: 1.0 }}
                value={colorState}
                className="uppercase"
                required
                disabled
              />
            </div>
          }
        />
        <div
          className="cursor-pointer right h-[26px] w-[26px] absolute rounded-sm right-[7.2px] bottom-[7.2px]"
          style={{
            backgroundColor: colorState,
          }}
          onClick={() => (disabled ? null : setOpenColorPicker(true))}
        />
      </div>
    </div>
  )
}

export function ColorInputWithSection({ color, onColorChange, colorOptions, brandColorOptions }) {
  const [openColorPicker, setOpenColorPicker] = useState(false)

  function handleOnColorChangeComplete(e) {
    const hexColor = e.hex.toUpperCase()
    onColorChange(hexColor)
  }

  return (
    <div className="flex items-center">
      <Popup
        basic
        wide
        content={
          <div className="flex flex-col p-[10px]">
            {brandColorOptions.length > 0 && (
              <div>
                <h4 className="mb-1">Brand colors</h4>
                <TwitterPicker
                  colors={brandColorOptions}
                  color={color}
                  onChangeComplete={(e) => handleOnColorChangeComplete(e)}
                  triangle="hide"
                  styles={{
                    default: {
                      card: {
                        border: 'none',
                        boxShadow: 'none',
                      },
                      body: {
                        padding: '0',
                      },
                      hash: {
                        display: 'none',
                      },
                      input: {
                        display: 'none',
                      },
                    },
                  }}
                />
              </div>
            )}

            <div>
              <h4 className="mb-1">Default palette</h4>
              <TwitterPicker
                colors={colorOptions}
                color={color}
                onChangeComplete={(e) => handleOnColorChangeComplete(e)}
                triangle="hide"
                styles={{
                  default: {
                    card: {
                      border: 'none',
                      boxShadow: 'none',
                    },
                    body: {
                      padding: '0',
                    },
                  },
                }}
              />
            </div>
          </div>
        }
        on="click"
        pinned
        position="bottom right"
        style={{ padding: 0 }}
        eventsEnabled
        open={openColorPicker}
        onClose={() => setOpenColorPicker(false)}
        onOpen={() => setOpenColorPicker(true)}
        trigger={
          <div className="cursor-pointer select-none mr-1 w-full">
            <input
              type="text"
              style={{ opacity: 1.0 }}
              value={color}
              className="uppercase"
              required
              disabled
            />
          </div>
        }
      />
      <div
        className="cursor-pointer h-[26px] w-[26px] -m-9 rounded-sm"
        style={{
          backgroundColor: color,
        }}
        onClick={() => setOpenColorPicker(true)}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ColorInput/index.js